<form class="rcs-card rcs-stack" (submit)="$event.preventDefault(); save()" data-testid="rcs-media-upload">
  <h4 class="rcs-card__title"><i class="fa fa-upload"></i> Cadastrar imagem na galeria</h4>
  <div class="rcs-grid-3">
    <div class="rcs-field">
      <label for="rcs-media-file">Imagem</label>
      <input id="rcs-media-file" type="file" class="form-control" accept="image/png,image/jpeg,image/gif,image/webp"
        (change)="onFile($event)" data-testid="rcs-media-file" />
    </div>
    <div class="rcs-field">
      <label for="rcs-media-title">Título</label>
      <input id="rcs-media-title" type="text" class="form-control" maxlength="80" name="title" [(ngModel)]="title"
        placeholder="Ex.: Frete grátis hoje" data-testid="rcs-media-title" />
    </div>
    <div class="rcs-field">
      <label for="rcs-media-category">Categoria</label>
      <select id="rcs-media-category" class="form-select" name="category" [(ngModel)]="category">
        <option *ngFor="let item of categories" [value]="item">{{ item }}</option>
      </select>
    </div>
  </div>
  <p class="rcs-hint">
    Para o card RCS Single, use imagem horizontal 16:9 (por exemplo 1200×675 px) em JPG ou PNG, de até 2 MB.
  </p>
  <p class="rcs-error" *ngIf="error" data-testid="rcs-media-error">{{ error }}</p>
  <div class="rcs-row rcs-row--end">
    <button type="button" class="sf-btn sf-btn--secondary" (click)="cancelled.emit()">Cancelar</button>
    <button type="submit" class="sf-btn sf-btn--primary" [class.is-loading]="saving" [disabled]="saving"
      data-testid="rcs-media-save">
      Enviar imagem <i class="fa fa-upload"></i>
    </button>
  </div>
</form>
